import { Suspense, lazy, useEffect, useRef } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import OrderPage from './pages/OrderPage';
import { track } from './lib/pixel';

/**
 * لوحة التحكم بتحميل كسول: يفتحها صاحب المتجر وحده، ولا يصحّ أن يحمّل كل
 * زائر كودها ولا مكتبة المصادقة التي تعتمد عليها.
 */
const AdminPage = lazy(() => import('./pages/AdminPage'));

/** أي انتقال بين الصفحات يبدأ من أعلى الشاشة لا من موضع التمرير السابق */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname]);

  return null;
}

/**
 * PageView عند كل تنقّل داخلي.
 *
 * الكود في index.html يطلق الحدث مرة عند التحميل، فأول تشغيل هنا يُتخطّى —
 * لولا ذلك لاحتُسبت زيارة الصفحة الأولى مرتين وارتفعت أرقام الحملات كذباً.
 */
function PixelPageViews() {
  const { pathname } = useLocation();
  const initial = useRef(true);

  useEffect(() => {
    if (initial.current) {
      initial.current = false;
      return;
    }
    track('PageView');
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <PixelPageViews />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/order" element={<OrderPage />} />
        <Route
          path="/admin"
          element={
            <Suspense
              fallback={
                <div className="min-h-screen flex items-center justify-center bg-z-light">
                  <i className="fa-solid fa-spinner fa-spin text-3xl text-z-navy" />
                </div>
              }
            >
              <AdminPage />
            </Suspense>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
